import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import booking from 'components/assets/img/icons/booking.svg';
import contact from 'components/assets/img/icons/contact.svg';
import transport from 'components/assets/img/icons/transport.svg';
import payments from 'components/assets/img/icons/payments.svg';
import T from 'components/common/translations/Translate';
import { connect } from 'react-redux';
import HeaderBack from 'components/components/account/components/HeaderBack';
import withRouter from 'components/components/common/withRouter';
import { setUserLogout } from 'components/actions/authActions';

class HowItWorks extends Component {

  render() {
    const {isLogged } = this.props;

    return (
      <div className="content content--lp content--lp-text">
        { isLogged &&
          <HeaderBack
            locale={this.props.locale}
            name="content.layout.sidebarAndHeader.help"
            link="routes.url.help"
            title="content.layout.sidebarAndHeader.backToHelpTitle"
            className="header-back--lp" />
        }

        <div className="row row--text row--text-wide">

          <div className="headline headline--subpage">
            <h1><T>content.landing.howItWorks.title</T></h1>
            <p><T>content.landing.howItWorks.description</T></p>
          </div>

          <ul className="howitworks-list">
            <li className="howitworks-list__item">
              <figure>
                <img src={booking} alt="" />
              </figure>
              <h4><T>content.landing.howItWorks.list.first.title</T></h4>
              <p><T>content.landing.howItWorks.list.first.description</T></p>
            </li>

            <li className="howitworks-list__item">
              <figure>
                <img src={contact} alt="" />
              </figure>
              <h4><T>content.landing.howItWorks.list.second.title</T></h4>
              <p><T>content.landing.howItWorks.list.second.description</T></p>
            </li>

            <li className="howitworks-list__item">
              <figure>
                <img src={transport} alt="" />
              </figure>
              <h4><T>content.landing.howItWorks.list.third.title</T></h4>
              <p><T>content.landing.howItWorks.list.third.description</T></p>
            </li>

            <li className="howitworks-list__item">
              <figure>
                <img src={payments} alt="" />
              </figure>
              <h4><T>content.landing.howItWorks.list.fourth.title</T></h4>
              <p><T>content.landing.howItWorks.list.fourth.description</T></p>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogout }
  )(HowItWorks));
